import { FC, SVGProps } from "react";

type Props = SVGProps<SVGSVGElement>;

/**
 * Check icon component with circular background
 */
export const CheckIcon: FC<Props> = ({ ...props }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="24" height="24" fill="none" stroke="none" />
    <rect
      width="22"
      height="22"
      x="1"
      y="1"
      rx="11"
      stroke="none"
      fill="currentColor"
    />
    <path
      d="M18 7.80002L9.59998 16.2L5.99995 12.6"
      stroke="white"
      strokeWidth="3"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
